<template>
  <div>
    <div class="is-flex is-justify-content-space-between">
      <button class="button" :class="{ 'is-dark': selected == 'timing' }" @click="selected = 'timing'">Timing</button>
      <button class="button" :class="{ 'is-dark': selected == 'owner' }" @click="selected = 'owner'">Owner</button>
      <button class="button" :class="{ 'is-dark': selected == 'status' }" @click="selected = 'status'">Status</button>
    </div>
    <br>
    <div class="my-6">
      <div v-if="selected == 'timing'" class="mx-auto" style="width: 350px">
        <Checkbox v-model="isMoveAllTiming" :checked="isMoveAllTiming">Update all alerts for this applicant ?</Checkbox>
        <br />
        <br />
        <Snooze v-model="timing" :selected_date="timing" />
        <br />
        <br />
        <button @click="argentMission" class="button is-info">נכנסה משימה דחופה יותר</button>
      </div>
      <div v-if="selected == 'owner'" class="has-text-centered">
        <select v-model="owner">
          <option v-for="option in dropdownAdminsNames" :key="option">{{ option }}</option>
        </select>
        <button @click="ownerPlus" class="button is-info mx-5" style="width: 40px">+</button>
        <button @click="ownerMinus" class="button is-info" style="width: 40px">-</button>
      </div>
      <div v-if="selected == 'status'" class="has-text-centered">
        <select v-model="status">
          <option value="active">active</option>
          <option value="in_progress">in_progress</option>
          <option value="done">done</option>
          <option value="irrelevant">irrelevant</option>
        </select>
      </div>
    </div>
    <div class="modal_footer">
      <a @click="submit()" class="button is-info">Submit</a>
      <div class="my-3 is-size-6 has-text-right is-flex-grow-1">id: {{ alert.id }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Snooze from '@/components/Snooze'
import Checkbox from './Checkbox.vue'

export default {
  name: 'FeedAlertEdit',
  components: {
    Snooze,
    Checkbox
  },
  props:
    {
      payload: {
        type: Object
      },
      alert: {
        type: Object,
        required: true
      },
      onSubmit: {
        type: Function,
        default: () => {}
      }
    },
  data () {
    return {
      selected: 'timing',
      timing: this.alert.timing,
      owner: this.alert.owner,
      status: this.alert.status,
      dynamicProperties: {},
      circumstances: 'normal',
      isMoveAllTiming: true
    }
  },
  computed: {
    ...mapGetters('admins', ['dropdownAdminsNames', 'getAdminByName'])
  },
  methods: {
    ...mapMutations('modals', ['create', 'removeModalById']),
    async updateAlert (reset = false) {
      await this.$network_utils.updateAlert({ id: this.alert.id, owner: this.owner, status: this.status, timing: this.timing, ...this.dynamicProperties })
      this.onSubmit(this.payload.modal_id, reset, this.circumstances)
    },
    argentMission () {
      this.timing = this.$moment().add(3, 'minutes')
      this.dynamicProperties.owner = this.$utils.getOwner().name
      this.circumstances = 'urgent'
      this.submit()
    },
    ownerPlus () {
      this.dynamicProperties.minimum_permission = 6
      this.owner = 'NULL'
      this.status = 'active'
      this.updateAlert(true)
    },
    ownerMinus () {
      this.dynamicProperties.maximum_permission = 5
      this.owner = 'NULL'
      this.status = 'active'
      this.updateAlert(true)
    },
    async submit () {
      try {
        let reset = false
        if (this.isMoveAllTiming) {
          await this.$network_utils.massUpdateAlert({
            id: this.alert.id,
            status: 'active',
            timing: this.timing,
            timing_all: 'true'
          })
          this.onSubmit(this.payload.modal_id, true, this.circumstances)
          return
        }
        if (this.owner != this.alert.owner) {
          this.status = 'active'
          const permissionLevel = this.getAdminByName(this.owner).permission_level
          if (permissionLevel > this.alert.maximum_permission) {
            this.dynamicProperties.maximum_permission = permissionLevel
          }
          if (permissionLevel < this.alert.minimum_permission) {
            this.dynamicProperties.minimum_permission = permissionLevel
          }
          this.dynamicProperties.maximum_permission = 'null'
          this.dynamicProperties.minimum_permission = 'null'
        }
        if (this.timing != this.alert.timing) {
          this.status = 'active'
          this.owner = ['follow_up_companies', 'manual_input', 'missions'].includes(this.alert.designator) ? this.owner : 'NULL'
        }
        if (['irrelevant', 'active'].includes(this.status) && this.status != this.alert.status) {
          reset = true
        }
        if (['done'].includes(this.status)) {
          reset = true
        }
        if (this.status == 'irrelevant') {
          this.create({
            designator: 'alert-form-modal',
            component_name: 'MessageForm',
            resource_data: this.alert,
            is_submitable: true,
            additional_data: { resource_type: 'Alert', endpoint: '/alerts/', headers: 'admin_headers' },
            modal_title: 'Message',
            props: {
              onSubmit: () => {
                this.removeModalById(this.payload.modal_id)
                this.updateAlert(reset)
              }
            }
          })
        } else {
          this.updateAlert(reset)
        }
      } catch (e) {
        console.log('error: ', e)
      }
    }
  }
}
</script>
